var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"amp-page"},[(_vm.showAmpPage)?_c('amp-main',{attrs:{"participant-id":_vm.participantId}}):_c('amp-form',{attrs:{"error":_vm.error},on:{"event:check-access":_vm.checkAccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/pages/axoft-maximum-pro/index.vue?vue&type=template&id=c79addbe&
// module id = 1239
// module chunks = 0